import { selectRecaptcha, useAppSelector } from '@open-tender/cloud'

const useAppHasRecpatcha = () => {
  const { addCard, signup, login, donations, giftCards } =
    useAppSelector(selectRecaptcha) || {}
  const appHasRecpatcha = addCard || signup || login || donations || giftCards
  return appHasRecpatcha
}

export default useAppHasRecpatcha
